import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const ButtonFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px 0px;
`;

export const DashboardTableWrapper = styled.div`
  overflow-x: hidden;

  table {
    table-layout: auto;
    border-collapse: collapse;
    margin-top: 0;
  }

  th, td {
    min-width: unset !important;
    white-space: nowrap;
  }

  thead th {
    left: unset !important;
    box-shadow: inset 0 -1px 0 ${({ theme }) => theme.colors.greyscale.gray15};
  }

  thead tr:first-of-type th {
    border-top: none;
  }

  th:nth-of-type(1),
  td:nth-of-type(1) {
    width: ${rem(32)};
    max-width: ${rem(48)};
    padding: ${rem(8)} ${rem(4)} !important;
  }

  tfoot {
    tr:nth-of-type(1) td {
      border-bottom: none;
    }

    tr {
      background-color: unset;
      td {
        line-height: ${rem(24)};
        padding-top: ${rem(20)};
        padding-bottom: ${rem(20)};
      }
    }
  }
`;

export const DashboardCardWrapper = styled.div`
  padding: 24px 0px;
`;

export const InvoiceDueDateColumnWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #b82525;
`;

export const ColumnColorWrapper = styled.div<{
  useThemeColor?: boolean;
}>`
  input {
    background-color: ${({ theme, useThemeColor }) =>
      useThemeColor ? theme.colors.semantic.dangerSecondaryHover : null};
    width: 100%;
  }
  svg path {
    fill: ${({ theme, useThemeColor }) =>
      useThemeColor ? theme.colors.primary.actionDefault : null};
  }
`;

export const RowSettingsButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  padding: 0;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(24)} 0px 0px 0px;
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(16)};
  flex-wrap: wrap;
`;

export const DatePickerWrapper = styled.div`
  flex-shrink: 0;
`;

export const ButtonFiltersWrapper = styled.div`
  display: flex;
  align-items: center;

  > div {
    margin-bottom: 0;
  }
`;

export const SearchWrapper = styled.div`
  flex-shrink: 0;
  flex-grow: 1;

  .search-container {
    margin-bottom: 0;
  }
  padding: 8px 0px;
`;

export const SearchRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(16)};
`;

export const ExportButtonWrapper = styled.div`
  flex-shrink: 0;
`;

//overrides datepicker color
export const StyledDatePickerWrapper = styled.div<{ iconColor?: string }>`
  svg,
  [class*='icon'],
  .datepicker-icon {
    color: ${({ iconColor }) => iconColor || 'inherit'};
    fill: ${({ iconColor }) => iconColor || 'inherit'};
  }
`;

export const TotalItemsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TotalItemsLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TotalItemsRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(16)};
`;

export const TotalItemsCount = styled.span`
  font-weight: 600;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.greyscale.gray40};
  text-transform: uppercase;
`;

export const NeedsAttentionWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold !important;
  color: black !important;
  font-size: ${rem(14)};
  padding: 0 0 0 ${rem(12)};
`;

export const DateRangeLabel = styled.span`
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.colors.greyscale.gray50};
  background-color: ${({ theme }) => theme.colors.greyscale.gray5};
  padding: ${rem(4)} ${rem(8)};
  border-radius: ${rem(4)};
`;

export const ResetFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterSeparator = styled.div`
  width: 1px;
  height: ${rem(20)};
  background-color: ${({ theme }) => theme.colors.greyscale.gray15};
  margin-right: ${rem(8)};
`;

export const ResetFiltersLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.greyscale.gray50};
  font-size: ${rem(14)};
  cursor: pointer;
  padding: ${rem(8)} ${rem(4)};
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.actionDefault};
  }
`;
